<template>
	<page-container>
		<p class="h2">欢迎使用AI快销</p>
		<template v-if="isShowCode">
			<div class="code-item">
				<canvas ref="canvas"></canvas>
				<p style="color: #ff5c50; cursor: pointer;" v-if="stateTip" @click="refresh">{{ stateTip }}</p>
				<p v-if="!stateTip">微信扫码，快捷登录</p>
				<div style="margin-top: 17px; width: 360px; margin-bottom: 43px;">
					<button class="form-btn" type="primary" @click="hideCode">账号登录</button>
					<p class="f-s-12 f-c-99" style="margin-top: 13px; text-align: left;">首次扫码登录，扫码后请手动登录即可绑定</p>
				</div>
			</div>
		</template>
		<template v-if="!isShowCode">
			<div class="input-item">
				<input class="form-input input-padd" type="text" autofocus placeholder="请输入您的手机号" @keyup.enter="login" @input="accountWarn = ''" v-model="form.account" />
				<img class="input-user-icon" src="../assets/user.png" alt="" />
				<div class="input-item-tip" v-if="accountWarn">{{ accountWarn }}</div>
			</div>
			<div class="input-item">
				<input class="form-input input-padd" type="password" autofocus @input="passwordWarn = ''" @keyup.enter="login" placeholder="请输入您的密码" v-model="form.password" />
				<img class="input-pass-icon" src="../assets/pass.png" alt="" />
				<div class="input-item-tip" v-if="passwordWarn">{{ passwordWarn }}</div>
			</div>
			<div class="flex-row" style="padding-top: 13px; padding-bottom: 30px;">
				<div class="checkbox" @click="autoLogin = !autoLogin">
					<img v-if="autoLogin" style="width: 20px; height: 20px;" src="../assets/checkbox.png" alt="" />
					<img v-else style="width: 20px; height: 20px;" src="../assets/checkbox-def.png" alt="" />
					<p style="margin-left: 12px;">自动登录</p>
				</div>
				<p class="f-s-16 button-min" @click="toPass">忘记密码</p>
			</div>
			<button class="form-btn" type="primary" @click="login" @keyup.enter="login">登录</button>
			<p class="f-s-12 f-c-99" style="margin-top: 10px;">登录即表示您已同意AI快销服务协议</p>
			<div class="button-wx" @click="showQrcode">
				<p>快捷登录</p>
				<img style="width: 24px; height: 24px; margin-left: 14px;" src="../assets/wx-icon.png" alt="" />
			</div>
		</template>
		<p slot="formFooter">没有账号？<span @click="register" class="button-min">立即注册</span></p>
		<div class="top-area f-c-primary">
			<p>{{ tips }}</p>
			<p>{{ tips2 }}</p>
		</div>
		<dialog-select slot="footer" ref="dialogSelect"></dialog-select>
	</page-container>
</template>

<script>
import pageContainer from '../components/page-container.vue';
import {getQueryVariable} from '../common/common.js';
import dialogSelect from '../components/select.vue';
import QRCode from 'qrcode';
const maxTime = 150;
export default {
	name: 'Login',
	data() {
		return {
			form: {
				account: '',
				password: '',
			},
			passwordWarn: '',
			autoLogin: true,
			accountWarn: '',
			loading: false,
			wxToken: '',
			tips: '',
			tips2: '',
			loginKey: '',
			isShowCode: false,
			qrcodeKey: '',
			stateTip: '',
			time: 0,
		};
	},
	components: {
		pageContainer,
		dialogSelect,
	},
	mounted() {
		window.localStorage.removeItem('USER_TOKEN');
		let history = window.localStorage.getItem('LAST_LOGIN_ID');
		history && (this.form = JSON.parse(history));
		let autoLogin = window.localStorage.getItem('AKX_AUTO_LOGIN_CONFIG');
		const type = window.localStorage.getItem('AKX_LAST_LOGIN_TYPE');
		if (type === 'WX') {
			this.showQrcode();
		}
		if (autoLogin === '-1') {
			this.autoLogin = false;
		}
		let userAgent = window.navigator.userAgent;
		if (userAgent.indexOf('AI快销-爱快销/5.1.8') !== -1) {
			// this.$component.download()
		}
		if (this.$route.params.phone && this.$route.params.password) {
			this.form.account = this.$route.params.phone;
			this.form.password = this.$route.params.password;
			this.login();
		}
	},
	methods: {
		login() {
			if (!this.loading && this.validation()) {
				this.loading = true;
				this.$api.login({
					headers: {
						token: this.wxToken,
					},
					params: {
						ORIGIN_API: true,
						'USER.LOGIN_ID': this.form.account,
						'USER.LOGIN_PASSWORD': this.form.password,
						APP_TOKEN: '9C4F2C2F67E34BB29BF296DBDBF26922',
						APP_SOURCE: 2,
						_KEY: this.loginKey,
					},
					success: res => {
						let result = res.extraData;
						if (result['USER_LIST'].length > 1) {
							result['USER_LIST'].map(ele => {
								ele.name = ele['USER.NAME'];
							});
							this.$refs.dialogSelect.show({
								list: result['USER_LIST'],
								title: '选择登录角色',
								select: res => {
									this.$api.selectService({
										params: {
											TOKEN: result.token,
											SERVICE_ID: res['USER.SERVICE_ID'],
											TYPE_NAME: res['USER.TYPE_NAME'],
											_KEY: this.loginKey,
										},
										success: res => {
											if (res.extraData.openIdStatus === 'fail') {
												alert('该账号已经绑定其他微信，本次绑定失败，可以去修改密码清空绑定');
											}
											result.bubuId = res.extraData.bubuId;
											this.loginSuccess(result);
										},
									});
								},
							});
						} else {
							if (result.openIdStatus === 'fail') {
								alert('该账号已经绑定其他微信，本次绑定失败，可以去修改密码清空绑定');
							}
							this.loginSuccess(result);
						}
					},
					fail: res => {
						if (res.msg) {
							if (res.msg.indexOf('密码') !== -1) {
								this.passwordWarn = res.msg;
							} else {
								this.accountWarn = res.msg;
							}
						}
					},
					complete: () => {
						this.loading = false;
					},
				});
			}
		},
		loginSuccess(result, scene) {
			let _this = this;
			let bubuId = result.bubuId;
			window.localStorage.setItem('AKX_AUTO_LOGIN_CONFIG', _this.autoLogin ? '1' : '-1');
			window.localStorage.setItem(
				'LAST_LOGIN_ID',
				JSON.stringify(
					Object.assign(
						{},
						_this.form,
						{
							password: '',
						}
					)
				)
			);
			window.sessionStorage.setItem('LOGIN_FLAG', '1');
			window.localStorage.setItem('USER_TOKEN', bubuId.substr(bubuId.length - 32, 32));
			if (scene !== 'code' && /^[0-9]*$/.test(this.form.password)) {
				window.localStorage.setItem('USER_LOGIN_PASSWORD_STATE', '0');
			} else {
				window.localStorage.removeItem('USER_LOGIN_PASSWORD_STATE');
			}
			let pathname;
			if (location.pathname.indexOf('login.html') !== -1) {
				pathname = location.pathname.replace('login.html', 'index.html');
			} else {
				pathname = '/';
			}
			let url = location.origin + pathname + '#' + (getQueryVariable('RETURN_URL') || '/');
			location.replace(url);
		},
		validation() {
			this.accountWarn = '';
			this.passwordWarn = '';
			if (!this.form.account) {
				this.accountWarn = '账号不能为空';
				return false;
			}
			if (!this.form.password) {
				this.passwordWarn = '密码不能为空';
				return false;
			}
			return true;
		},
		wxLogin(res) {
			if (res.state === 2) {
				this.tips = '首次扫码登录';
				this.tips2 = '请在下方登录后即可绑定';
				this.isShowCode = false;
				this.wxToken = res.token;
				this.loginKey = res._KEY;
			} else if (res.state === 3) {
				this.autoLogin = true;
				this.loginSuccess(res, 'code');
			}
		},
		register() {
			this.$router.push({
				path: '/register',
			});
		},
		toPass() {
			this.$router.push({
				path: '/pass',
			});
		},
		showQrcode() {
			this.loginKey = '';
			this.tips = '';
			this.tips2 = '';
			this.wxToken = '';
			this.isShowCode = true;
			this.time = 0;
			this.$nextTick(() => {
				this.getQrcodeKey();
				this.qrcode();
				this.getLoginState(this.qrcodeKey);
			});
			localStorage.setItem('AKX_LAST_LOGIN_TYPE', 'WX');
		},
		getQrcodeKey() {
			this.qrcodeKey = Math.floor(Math.random() * (1e16 - 1e15 + 1)) + 1e15 + '';
		},
		qrcode() {
			const version = process.env.NODE_ENV === 'development' ? 'dev' : 'work';
			QRCode.toCanvas(
				this.$refs.canvas,
				'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb8aedfd8c6a5b491&redirect_uri=https%3A%2F%2Fsys.ai.kxkx888.com%2Fshare-sys%2F' +
					version +
					'%2Findex.html%23%2Fwxlogin' +
					encodeURIComponent('?key=' + this.qrcodeKey) +
					'&response_type=code&scope=snsapi_base&state=1#wechat_redirect',
				function(error) {
					if (error) console.error(error);
					console.log('success!');
				}
			);
		},
		refresh() {
			this.showQrcode();
			this.stateTip = '';
		},
		getLoginState(code) {
			this.$api.getWxLoginState({
				params: {
					_KEY: code,
				},
				success: res => {
					if (res.extraData.satus === 2 || res.extraData.satus === 3) {
						this.wxLogin(
							Object.assign(
								{
									_KEY: code,
									bubuId: res.extraData.token,
									state: res.extraData.satus,
								},
								res.extraData
							)
						);
						return;
					}
					if (res.extraData.satus === 1 || this.time >= maxTime) {
						this.stateTip = '已失效，点我刷新';
						return;
					}
					setTimeout(() => {
						if (this.qrcodeKey === code) {
							this.getLoginState(code);
							this.time++;
						}
					}, 2000);
				},
			});
		},
		hideCode() {
			this.qrcodeKey = '';
			this.isShowCode = false;
			localStorage.removeItem('AKX_LAST_LOGIN_TYPE');
		},
	},
};
</script>

<style scoped lang="scss">
.h2 {
	font-size: 24px;
	color: #333333;
	line-height: 36px;
	font-weight: 500;
	margin-bottom: 31px;
}
.input-item {
	padding-bottom: 17px;
	padding-top: 17px;
	position: relative;
}
.input-item-tip {
	position: absolute;
	left: 0;
	bottom: -8px;
	font-size: 14px;
	color: #f46c50;
	line-height: 21px;
}
.input-item-tip:before {
	content: '';
	display: inline-block;
	width: 14px;
	height: 14px;
	background-position: center;
	background-size: contain;
	vertical-align: middle;
	margin-right: 6px;
	background-image: url(../assets/cut.png);
}
.button-min {
	color: #f46c50;
	cursor: pointer;
}
.button-min:hover {
	opacity: 0.8;
}
.top-area {
	position: absolute;
	top: 10px;
	right: 10px;
	font-size: 12px;
	text-align: right;
	align-items: flex-end;
	display: flex;
	flex-direction: column;
}

.f-c-primary {
	color: #ff5c50;
}

.code-item {
	text-align: center;
	font-size: 18px;
	color: #999;
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 250px;
	margin: 0 auto;
	margin-top: -20px;
}

.button-wx {
	line-height: 27px;
	font-size: 18px;
	display: flex;
	color: #999999;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
	margin-top: 36px;
	margin-bottom: 39px;
}
.button-wx:hover {
	opacity: 0.85;
}
.flex-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}

.checkbox {
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 16px;
	cursor: pointer;
}

.input-padd {
	padding-left: 46px;
}
.input-user-icon {
	width: 20px;
	height: 21px;
	position: absolute;
	top: 33px;
	left: 13px;
}

.input-pass-icon {
	width: 24px;
	height: 24px;
	position: absolute;
	top: 31px;
	left: 10px;
}
</style>
